import BaseMessageHandler from '../BaseMessageHandler';
import { setUserTips } from 'actions/user';

export default class HelpTips_List extends BaseMessageHandler {
  success = () => {
    const { dispatch, message } = this;
    dispatch(setUserTips(message.payload?.list));
  };
}
